import React, { useState } from "react";
import axios from "axios";
import emailjs from "emailjs-com";
import ReactSelect from "react-select";
import { servicesOptions } from "../../data";

const EnquiryForm = ({ color = "bg-white", selectColor = "white" }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    phone: "",
    services: "",
    serviceArr: [],
  });

  const [sendStatus, setSendStatus] = useState("send");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelect = (e) => {
    console.log(e);
    setFormData({
      ...formData,
      services: formatSelected(e),
      serviceArr: e,
    });
  };

  const handleSubmit = (e) => {
    setSendStatus("sending");
    e.preventDefault();
    submitData();
    sendEmail(e);
  };

  const formatSelected = (e) => {
    const labels = e.map((item) => item.label).join(", ");
    return labels;
  };

  const submitData = async () => {
    try {
      const response = await axios.post(
        `https://sheetdb.io/api/v1/yafyjwzsry5xn`,
        formData,
        {
          headers: {
            Authorization: "Bearer zjl73usmej8rwi7kwlrxtvxa79bt60izsxiqlv7f", // Replace with your SheetDB API key
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 201) {
        setSendStatus("sent");
        setFormData({
          name: "",
          email: "",
          message: "",
          phone: "",
          services: "",
          serviceArr: [],
        });

        setTimeout(() => {
          setSendStatus("send");
        }, 2000);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  const sendEmail = (e) => {
    emailjs
      .sendForm(
        "cccs24x7online",
        "template_6qqkb1s",
        e.target,
        "er_NY-NEcNOk5-Ih8"
      )
      .then(
        (result) => {
          // console.log(result);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "50px",
      display: "flex",
      paddingLeft: "4px",
      alignItems: "center",
      width: "100%",
      border: "1px solid #D1D5DB",
      borderRadius: "0.25rem",
      backgroundColor: selectColor,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    input: (provided, state) => ({
      ...provided,
      boxShadow: "none",
      border: "none",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: "rgba(0,0,0,0.7)",
    }),
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full flex flex-col items-center justify-center max-w-[450px] h-full gap-4 mb-10"
    >
      <div className="w-full">
        <input
          type="text"
          name="name"
          aria-label="Your Name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Your Name *"
          required
          className={`${color} placeholder-black/70 h-[50px] flex items-center w-full border border-gray-300 rounded text-black`}
        />
      </div>

      <div className="w-full">
        <input
          type="email"
          name="email"
          aria-label="Your Email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Your Email *"
          required
          className={`${color} placeholder-black/70 h-[50px] flex items-center w-full border border-gray-300 rounded text-black`}
        />
      </div>

      <div className="w-full">
        <input
          type="tel"
          name="phone"
          aria-label="Your Phone Number"
          value={formData.phone}
          onChange={handleChange}
          placeholder="Your Phone Number *"
          required
          className={`${color} placeholder-black/70 h-[50px] flex items-center w-full border border-gray-300 rounded text-black`}
        />
      </div>

      <div className="w-full">
        <ReactSelect
          name="services"
          aria-label="Select the Service/s"
          className="react-select"
          onChange={handleSelect}
          options={servicesOptions}
          value={formData.serviceArr}
          isMulti
          styles={customStyles}
          required
          placeholder="Select the Service/s *"
        />
      </div>

      <div className="w-full">
        <textarea
          name="message"
          aria-label="Message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Message"
          rows={5}
          required
          className={`${color} placeholder-black/70 flex items-center w-full border border-gray-300 rounded text-black`}
        />
      </div>

      <div className="flex justify-center w-full">
        <button
          type="submit"
          className="flex items-center justify-center bg-lightblue-5 text-blue-6 hover:text-blue-4 uppercase text-md w-full px-4 h-[50px] shadow-md  hover:bg-lightblue-6 rounded"
        >
          {sendStatus === "sending" ? (
            <span className="material-symbols-outlined animate-spin">
              progress_activity
            </span>
          ) : (
            sendStatus
          )}
        </button>
      </div>

      <div
        className={`text-md text-center text-white h-[100px] px-6 bg-blue-8/60 duration-300 rounded-xl absolute z-10 items-center justify-center max-w-[350px] border-2 border-lightblue-4 shadow-lg transition-all ${
          sendStatus === "sent" ? "opacity-100 flex" : "opacity-0 hidden"
        }`}
      >
        Thank you for contacting us. We will get back to you soon!!
      </div>
    </form>
  );
};

export default EnquiryForm;
